module.exports = __webpack_public_path__ + "assets/eccfdc4126e3d0df059f302bc84a5fc7.png";